import { Injectable } from '@angular/core';
import { toZonedTime, fromZonedTime } from 'date-fns-tz';

const ET_ZONE = 'America/New_York';

@Injectable({ providedIn: 'root' })
export class TimezoneService {

  easternDateTimeStringToUtcISO(localEasternISO: string | Date | null): string | null {
    if (!localEasternISO) return null;
    const utc = fromZonedTime(localEasternISO, ET_ZONE);
    return utc.toISOString();
  }


  utcISOToEasternDateTimeString(utcISO: string | null) {
    // console.log("Converting UTC ISO to Eastern Time:", utcISO);
    if (!utcISO) return '';
    const d = toZonedTime(new Date(utcISO), ET_ZONE);
    // console.log("Converted date:", d);
    return d;
  }

  /**
   * Converts the date fields to Eastern Time and updates the event object in place.
   * @param event An event object with start_date, end_date, vod_expiration_date in UTC ISO format
   */
  eventToEasternTime(event: any) {
    if (event.start_date) {
      event.start_date = this.utcISOToEasternDateTimeString(event.start_date);
    }
    if (event.end_date) {
      event.end_date = this.utcISOToEasternDateTimeString(event.end_date);
    }
    if (event.vod_expiration_date) {
      event.vod_expiration_date = this.utcISOToEasternDateTimeString(event.vod_expiration_date);
    }
    // console.log('Converted event to ET:', event);
  }
}